import { CheckCircle, CircleDashed, Loader2, XCircle } from "lucide-react";
import { cn } from "~/lib/utils";
import type { TaskInstanceState } from "~/services/publicDatasetRuns";
import { taskStateBucket } from "./publicDatasetTaskGroups";

// Uses the shared `taskStateBucket` classifier, so this can't drift out of
// sync with the task list's count-breakdown label. Icon set matches
// `ValidationJobCard`'s checklist icons for visual consistency.
export const TaskInstanceStateIconMap = (
  state: TaskInstanceState | null,
  className?: string
): React.ReactNode => {
  switch (taskStateBucket(state)) {
    case "success":
      return <CheckCircle className={cn("text-green-600", className)} aria-hidden />;
    case "running":
      return <Loader2 className={cn("animate-spin text-primary", className)} aria-hidden />;
    case "failed":
      return <XCircle className={cn("text-destructive", className)} aria-hidden />;
    case "retrying":
      return <CircleDashed className={cn("text-yellow-600", className)} aria-hidden />;
    case "pending":
      return <CircleDashed className={cn("text-muted-foreground", className)} aria-hidden />;
  }
};
